import React,{Component} from 'react';
import $ from 'jquery';
import { Link, browserHistory } from 'react-router';
import {Panel,Modal,Button} from 'react-bootstrap';
import { ShareButtons, generateShareIcon } from 'react-share';


const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');
const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

export default class OffersDetails extends Component {
	constructor(props){
		super(props);
			this.state={
					tid : this.props.params.Tid,
					type: this.props.params.Type,
					dtype: this.props.params.DType,
					pdeals: [],
					totdata: '',
					prevPath: '',
					brands: [],
					categories: [],
					brands_status: false,
					cat_status: false,
					nodata: false,
          open: false,
          img_price: 'price.png',
          img_data: 'Price',
          sort_status: 1,
          sort: '1',
          latitude: '',
          longitude: '',
          cart_count:0,
			};
			this.getBrands=this.getBrands.bind(this);
			this.getSelectedBrand=this.getSelectedBrand.bind(this);
      this.getSort=this.getSort.bind(this);
      this.getNearBy=this.getNearBy.bind(this);
      this.getDeviceId=this.getDeviceId.bind(this);
      this.getCartCount=this.getCartCount.bind(this);
	};

  getCartCount()
  {
      if(localStorage.user_id)
      {
        var uid = localStorage.user_id;
      }
      else
      {
         uid =0;
      }
    var data1={from: 'mobile_web',id:uid,token:localStorage.getItem('token')};
    var data2=JSON.stringify(data1);
    $.ajax({
          method: 'POST',
          url: baseUrl+'cart_count',
          dataType:'json',
          data: {req:data2},
          success: function(data)
          {

            this.setState({
                cart_count:data.cart_count,
            });
          }.bind(this),
          error: function(err){
          
          }
    }) 
  }
  // showPosition(position) {
  //     localStorage.setItem('lat',position.coords.latitude);
  //     localStorage.setItem('long',position.coords.longitude);
  //     this.setState({
  //       latitude: position.coords.latitude,
  //       longitude: position.coords.longitude,
  //     });
  // }
  getDeviceId()
  {
    if(localStorage.user_id){
        var user_id=localStorage.user_id;
    }
    else{
      user_id=0;
    }
    var data1={from: 'mobile_web',id: user_id, device_id: localStorage.getItem('push_device_id')}
    var data2=JSON.stringify(data1);
    $.ajax({
        method: 'POST',
        url: baseUrl+'getDeviceId',
        dataType: 'json',
        data:{req: data2},
        success: function(data){
          
        },
        error: function(err){
        }
    });
  }

  // showError(error)
  // {
  //   switch(error.code) {
  //       case error.PERMISSION_DENIED:
  //           // console.log("User denied the request for Geolocation.");
  //           break;
  //       case error.POSITION_UNAVAILABLE:
  //           // console.log("Location information is unavailable.");
  //           break;
  //       case error.TIMEOUT:
  //           // console.log("The request to get user location timed out.");
  //           break;
  //       case error.UNKNOWN_ERROR:
  //           // console.log("An unknown error occurred.");
  //           break;
  //       default: 
  //           console.log('');
  //       break;
  //   }
  // }

	getBrands()
  {

		var data1={from: 'mobile_web',type:this.state.type, tid: this.state.tid, dtype:this.state.dtype};
		var data2=JSON.stringify(data1);
	  $.ajax({
  	    	method: 'POST',
      		url: baseUrl+'filterBrandCat',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data){
          		if(data.brands_lst.length > 0){
            			this.setState({
            				brands_status: true,
            			});
          		}
              if(data.cat_lst.length > 0){
                  this.setState({
                    cat_status: true,
                  });
              }
    	    		this.setState({
    	       			brands:data.brands_lst,
    	       			categories: data.cat_lst,
    	     		});
  			  }.bind(this),
  			  error: function(err){
  				}
    });
	}

	getCategories()
  {

		var data1={from: 'mobile_web',type:this.state.type, tid: this.state.tid, dtype:this.state.dtype};
		var data2=JSON.stringify(data1);
	  $.ajax({
  	    	method: 'POST',
      		url: baseUrl+'filterBrandCat',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data){
          },
  			  error: function(err){
  				}
    });
	}

	getSelectedBrand(b)
  {
      var uid =0;
      if(localStorage.user_id)
      {
        uid=localStorage.getItem('user_id')
      }
      else
      {
        uid=0;
      }

	    var data1={from: 'mobile_web',uid:uid,type:this.state.type, tid: this.state.tid, dtype:this.state.dtype, bid: b};
	    var data2=JSON.stringify(data1);
      $.ajax({
          method: 'POST',
          url: baseUrl+'getProductbycat_brand',
          dataType:'json',
          data: {req:data2},
          success: function(data){
              if(data.result.length === 0){
                	this.setState({
                		nodata: true,
                	})
              }
              else{
                	this.setState({
                		nodata: false,
                	});
              }
              this.setState({
                  pdeals:data.result,
                  totdata: data,
              });
          }.bind(this),
          error: function(err){
          }
        });
	}

  getSelectedCategory(c)
  {
	    var uid =0;
      if(localStorage.user_id)
      {
        uid=localStorage.getItem('user_id')
      }
      else
      {
        uid=0;
      }
	    var data1={from: 'mobile_web',uid:uid,type:this.state.type, tid: this.state.tid, dtype:this.state.dtype, cat_id: c};
	    var data2=JSON.stringify(data1);
      $.ajax({
          method: 'POST',
          url: baseUrl+'getProductbycat_brand',
          dataType:'json',
          data: {req:data2},
          success: function(data){
    	      if(data.result.length === 0){
      	      	this.setState({
      	      		nodata: true,
      	      	})
      	    }
    	      else{
    	      	  this.setState({
    	      		   nodata: false,
    	      	  });
    	      }
            this.setState({
              	pdeals:data.result,
              	totdata: data,
            });
          }.bind(this),
          error: function(err){
          }
      });
	}
  componentDidMount()
  {
      if(screen.width >= 800){
        window.location.href="/web/offers/deals/"+this.props.params.Tid+"/"+this.props.params.Type+"/1";
      }
  		localStorage.setItem('offers','/offers/deals/'+this.props.params.Tid+'/'+this.props.params.Type+'/'+this.props.params.DType);
  		
  		// if(navigator.geolocation){
    //     	navigator.geolocation.getCurrentPosition(this.showPosition,this.showError);
    //   }
    //   else{
    //     // alert("GeoLocation is not supported by the browser");
    //   }
      this.getBrands();
      this.getDeviceId();
      if(localStorage.user_id && localStorage.token)
      {
        this.getCartCount();  
      }
      
      var data1= '';
      var data2= '';
      var get_function= '';
      var uid =0;
      if(localStorage.user_id)
      {
        uid=localStorage.getItem('user_id')
      }
      else
      {
        uid=0;
      }
      if(this.state.type === 'offers'){
          data1= {from:'mobile_web',uid:uid,deal_offer_type: this.state.dtype, type: ''};
          data2= JSON.stringify(data1);
          get_function='getProductbycat_brand';
          this.get_product_list(data2,baseUrl,get_function);
      }
      if(this.state.type === 'brand')
      {
          data1={from: 'mobile_web',uid:uid,type:this.state.type, tid: this.state.tid, dtype:this.state.dtype};
          data2=JSON.stringify(data1);
          get_function='getProductbycat_brand';
          this.get_product_list(data2,baseUrl,get_function);
      }
      else{
          data1= {from:'mobile_web',uid:uid,discount: this.state.tid, discount_type: this.state.dtype, discount_opr: this.state.type};
          data2= JSON.stringify(data1);get_function='getNewsearch';
          this.get_product_list(data2,baseUrl,get_function);
      }
  }
  get_product_list(data2,baseUrl,get_function)
  {
      $.ajax({
          method: 'POST',
          url: baseUrl+get_function,
          dataType:'json',
          data: {req:data2},
          success: function(data){
              if(data.products.length === 0){
                  this.setState({
                      nodata: true,
                  })
              }
              else if(this.state.tid === '49'){
                  this.setState({
                      nodata: true,
                  })
              }
              else{
                  this.setState({
                      nodata: false,
                  })
              }
            this.setState({
                pdeals:data.products,
                totdata: data,
            });
          }.bind(this),
          error: function(err){
          }
      });
  }
  getSort()
  {
    var uid =0;
    if(localStorage.user_id)
    {
      uid=localStorage.getItem('user_id')
    }
    else
    {
      uid=0;
    }
    var data1={from: 'mobile_web',uid:uid,sort:this.state.sort,discount: this.state.tid, discount_type: this.state.dtype, discount_opr: this.state.type};
    var data2=JSON.stringify(data1);
    $.ajax({
        method: 'POST',
        url: baseUrl+'getNewsearch',
        dataType:'json',
        data: {req:data2},
        success: function(data){
           if(this.state.sort === 1)
           {
              var ss = 2;
              var img_price = 'down.png';
              var img_data = 'High - Low';
           }
           else
            {
              ss = 1;
              img_price = 'up.png';
              img_data ='Low - High';
            }
            this.setState({
                sort: ss,
                img_price: img_price,
                img_data: img_data,
            });
            this.setState({
                pdeals:data.products,
                totdata: data,
            });
        }.bind(this),
        error: function(err){
        }
    });
  }

  getNearBy()
  {
    var uid =0;
    if(localStorage.user_id)
    {
      uid=localStorage.getItem('user_id')
    }
    else
    {
      uid=0;
    }

    var data1={from: 'mobile_web',uid:uid,lat:this.state.latitude,long:this.state.longitude,discount: this.state.tid, discount_type: this.state.dtype, discount_opr: this.state.type};
    var data2=JSON.stringify(data1);
    $.ajax({
      method: 'POST',
      url: baseUrl+'getNewsearch',
      dataType: 'json',
      data:{req: data2},
      success: function(data){
       if(data.products.length === 0){
            this.setState({
              nodata: true,
            })
        }
        else{
          this.setState({
              nodata: false,
              pdeals:data.products,
              totdata: data,            
          });
        }
      }.bind(this),
      error: function(err){
      }
    });
  }

	render(){
	var products = this.state.pdeals.map((product,index) => (<ProductsList key={product.pid} data={product} />));
		return (
	<div className="mob_deals m_offer_details_page ">
  		<div className="page_hdr">
    			<div className="container-fluid">
      				<h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link> Flat {this.state.tid}% off</h5>
              <a href="/" className="home_logo1"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home" /></a>
              <a className="mob_cart_btn" href="/mycart">
                <img alt="" src={baseAssets+'icons/web_icons/cart_icon.png'} />
                {this.state.cart_count > 0 ? <span className={this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count"} >{this.state.cart_count}</span> : ''}
              </a>
    			</div>
  		</div>
		  <div className="pag_cntnt">&nbsp;</div>
		  <section className="container-fluid">
  			  {this.state.nodata ? 
            <div className="no_data">
  				    <h3>No Deals Available</h3>
				      <p>Need something here? <Link to={"/customer_care"}>CONTACT US</Link> now !</p>
				    </div> : products }
		  </section>
		  <div className="clr">&nbsp;</div>
		  <div className="clr">&nbsp;</div>
		  <div className="clr">&nbsp;</div>
		  <div className="clr">&nbsp;</div>
  </div>
		);
	}
}

class ProductsList extends Component {
	constructor(){
    super();
    this.state={
      open: false,
      msg: '',
      shareUrl: '',
    };
    this.ShareFunc=this.ShareFunc.bind(this);
    this.addToCart=this.addToCart.bind(this);
    // this.updateCartCount=this.updateCartCount.bind(this);
    this.close=this.close.bind(this);
    this.replaceCartItems=this.replaceCartItems.bind(this);
    this.addToQuickCart=this.addToQuickCart.bind(this);
  }
  replaceCartItems(deal_id,quantity)
  {
      if(localStorage.user_id)
      {
        var uid = localStorage.user_id;
      }
      else
      {
         uid =0;
      }
    if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
    var data1={from: 'mobile_web',id:uid,token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1,quantity:quantity,pl_size:0,salinity:0,pickup_date:0,source:source,campaign:campaign,url_id:url_id}
    var data2=JSON.stringify(data1);
    $.ajax({
      method:'post',
      dataType:'json',
      url: baseUrl+'replaceCart',
      data:{req:data2},
      success:function(data)
      {
        if(data.status==="success")
        {
          this.setState({
            clearcart_status:false,
          });
          browserHistory.push('/mycart');
        }
      }.bind(this),
      error:function(err)
      {

      }
    });
  }
  close()
  {
    this.setState({
      clearcart_status:false,
      already_added_status:false,
    });
  }
  addToQuickCart(deal_id)
  {
      if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
      if(!localStorage.user_id && !localStorage.token)
      {
          browserHistory.push('/login');
      }
      else
      {
          if(localStorage.user_id)
          {
            var uid = localStorage.user_id;
          }
          else
          {
             uid =0;
          }
          var data1={from: 'mobile_web',id:uid,token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1,source:source,campaign:campaign,url_id:url_id}
          var data2=JSON.stringify(data1);
          $.ajax({
            method:'post',
            dataType:'json',
            url: baseUrl+'addToQCart',
            data:{req:data2},
            success:function(data)
            {
              if(data.status==="success")
              {
                this.updateCartCount();
                browserHistory.push('/quickcart');
              }
              else if(data.status==="error" && data.cart_flag===0)
              {
                this.setState({
                  clearcart_status: true,
                });
              }
              else if(data.status==="error" && data.message==="Product already added to the cart")
              {
                this.setState({
                  already_added_status: true,
                });
              }
            }.bind(this),
            error:function(err)
            {

            }
          });
        }
  }
  addToCart(deal_id)
  {
     if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
     if(!localStorage.token && !localStorage.user_id)
     {
     	browserHistory.push('/login');
     }
     else
     {
        if(localStorage.user_id)
        {
          var uid = localStorage.user_id;
        }
        else
        {
           uid =0;
        }
          var data1={from: 'mobile_web',id:uid,token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1,source:source,campaign:campaign,url_id:url_id}
          var data2=JSON.stringify(data1);
          $.ajax({
              method:'post',
              dataType:'json',
              url: baseUrl+'quickBuy',
              data:{req:data2},
              success:function(data)
              {
                  if(data.status==="success")
                  {
                    // this.updateCartCount();
                    browserHistory.push('/mycart');
                  }
                  else if(data.status==="error" && data.cart_flag===0)
                  {
                    this.setState({
                      clearcart_status: true,
                    });
                  }
                  else if(data.status==="error" && data.message==="Product already added to the cart")
                  {
                    this.setState({
                      already_added_status: true,
                    });
                  }
                  else if(data.status==="error" && data.message==="Token mismatch")
                  {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user_id');
                    browserHistory.push('/login');
                  }
              }.bind(this),
              error:function(err)
              {

              }
        });
     }
  }
  ShareFunc(evnt)
  {
      var data1={from: 'mobile_web',type:1,did:evnt};
      var data2=JSON.stringify(data1); 
      $.ajax({
          method: 'POST',
          url: baseUrl+'createTinyurl',
          dataType:'json',
          data: {req:data2},
          success: function(data){
              this.setState({
                  msg: data.msg,
                  shareUrl: data.tinyurl,
              });
          }.bind(this),
          error: function(err){
          }
        });
      this.setState({ open: !this.state.open });
      setTimeout(() => {this.setState({open: false}); }, 5000);
  }

  render(){
		var mydata=this.props.data;
    var shareUrl = this.state.shareUrl;
    var title = "Hey! Click here " + shareUrl + " to check " + mydata.brand_name +" " + mydata.quantity + " from AquaDeals.";
		return (
			<div className="list_card">
        {mydata.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+mydata.promo_ribbion} alt="" /></i> : ''}
			   {mydata.dealcount >1 ? <Link to={"/subdeals/"+mydata.pro_id} >  
			   <div className="list_img">
				  	<img src={baseAssets+'images/product_imgs/'+mydata.image} alt="Deal" role="presentation" />
			   </div>
  			<div className="list_txt">
    				<h4>{mydata.brand_name} {mydata.quantity}</h4>
    				<h5>{mydata.brand_name}</h5>
    				{mydata.dealcount >=2 ? <h3>{mydata.dealcount} deals available</h3> : ''}
    				{mydata.over_rate >=1 ? <h6><i className="glyphicon glyphicon-star"></i>{mydata.over_rate}</h6>: <h6><i className="glyphicon glyphicon-star no_star"></i></h6>}
  			</div>
			</Link> : 
      <Link to={"/pdetails/"+mydata.url_dtype_name+"/"+mydata.url_cat_name+"/"+mydata.url_brand_name+"/"+mydata.url_product_name+"/"+mydata.pro_id+"/"+mydata.id} >
			      <div className="list_img">
					      <img src={baseAssets+'images/product_imgs/'+mydata.image} alt="Deal" role="presentation" />
			      </div>
			      <div className="list_txt">
        				{mydata.brand_name ? <h4>{mydata.brand_name} {mydata.quantity}</h4> : ''}
        				<h5>{mydata.brand_name}</h5>
        				{mydata.dealcount >=2 ? <h3>{mydata.dealcount} deals available</h3> : ''}
                {mydata.pricediff ? <h3>aquacash discount &#8377;{mydata.pricediff}</h3> : ''}
                {mydata.over_rate >=1 ? <h6><i className="glyphicon glyphicon-star"></i>{mydata.over_rate}</h6>: <h6><i className="glyphicon glyphicon-star no_star"></i></h6>}
      			</div>
			</Link>}

      <Link className="share_list" onClick={()=>{this.ShareFunc(mydata.id)}}><img src={baseAssets+'images/web_imgs/share1.png'} alt="" /></Link>
      {mydata.deal_views >0 ? <h6 className="views_eye"><img src={baseAssets+'images/web_imgs/eye.png'} width="17px" role="presentation"/> {mydata.deal_views} {mydata.deal_views >1 ?  'Views' : 'View'} </h6> : ''}
      {/*{mydata.dealcount >= 2 ? '' : <a className="quick_buy_img" onClick={()=>this.addToCart(mydata.id)}><img src={baseAssets+"images/icons/quick_buy.png"} alt=" " width="50px" /></a>}*/}
      {mydata.dealcount >= 2 ? '' : <a className="quick_buy_img" onClick={()=>this.addToQuickCart(mydata.id)}><img src={baseAssets+"images/icons/quick_buy.png"} alt=" " width="50px" /></a>}
      <div>
          <Panel className="share_panel" collapsible expanded={this.state.open}>
              <FacebookShareButton url={shareUrl} quote={title} className="test_share">
                  <FacebookIcon size={32} round />
              </FacebookShareButton>
              <TwitterShareButton url={shareUrl} quote={title} className="test_share">
                  <TwitterIcon size={32} round />
              </TwitterShareButton>
              <GooglePlusShareButton url={shareUrl} className="test_share">
                  <GooglePlusIcon size={32} round />
              </GooglePlusShareButton>
          </Panel>
      </div>
      {/* Modal for Replaceing the other cart items */}
    <Modal className="m_pro_full_dtls_modal"  show={this.state.clearcart_status} onHide={this.close}  >
    <Modal.Header closeButton>
        <Modal.Title style={{fontSize: '16px',color:'#333'}}>Alert</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4 style={{fontSize:'14px', color:'#333'}}>You can't have multiple seller items in the cart. Empty existing cart & add this item {mydata.title}?</h4>
      </Modal.Body>
      <Modal.Footer className="modal_footer">
        <Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>NO</Button>
        <a><Button style={{background:'none',border:'none',color: '#ff742a'}} onClick={()=>{this.replaceCartItems(mydata.deal_id,mydata.min_qty)}}>YES</Button></a>
      </Modal.Footer>
  </Modal>

  {/* Modal for Showing the response of Already existing product */}
  <Modal className="m_pro_full_dtls_modal"  show={this.state.already_added_status} onHide={this.close}  >
    <Modal.Header closeButton>
        <Modal.Title style={{fontSize: '16px',color:'#333'}}>Alert</Modal.Title>
      </Modal.Header> 
      <Modal.Body>
        <h4 style={{fontSize:'14px', color:'#333'}}>Product already added to the cart</h4>
      </Modal.Body>
      <Modal.Footer className="modal_footer">
        <Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>OK</Button>
    </Modal.Footer>
  </Modal>
  </div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Feed/offers_details.js
 **/